var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50016 17.4166C5.12779 17.4166 1.5835 13.8723 1.5835 9.49992C1.5835 5.12755 5.12779 1.58325 9.50016 1.58325C10.7293 1.58233 11.9418 1.86807 13.0412 2.41778C14.1406 2.96749 15.0967 3.76602 15.8335 4.74992H13.6881C12.7739 3.94381 11.6465 3.41862 10.4412 3.23736C9.23595 3.0561 8.00396 3.22648 6.89312 3.72805C5.78227 4.22961 4.83974 5.04107 4.17863 6.06503C3.51753 7.08899 3.16593 8.28196 3.16604 9.5008C3.16614 10.7196 3.51793 11.9125 4.17921 12.9364C4.84048 13.9603 5.78314 14.7715 6.89408 15.2729C8.00501 15.7743 9.23702 15.9445 10.4423 15.763C11.6475 15.5816 12.7748 15.0562 13.6889 14.2499H15.8343C15.0974 15.2339 14.1412 16.0325 13.0417 16.5822C11.9421 17.132 10.7295 17.4176 9.50016 17.4166ZM15.0418 12.6666V10.2916H8.7085V8.70825H15.0418V6.33325L19.0002 9.49992L15.0418 12.6666Z",
    fill: "#8295B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d6065a7eb7bbc240fd2134021aa571cc.svg";
export { ForwardRef as ReactComponent };